export default [{
  name: '中国大陆',
  english: 'CN'
}, {
  name: '中国台湾',
  english: 'TW'
}, {
  name: '中国香港',
  english: 'HK'
}, {
  name: '中国澳门',
  english: 'MA'
}, {
  name: '美国',
  english: 'US'
}, {
  name: '英国',
  english: 'GB'
}, {
  name: '日本',
  english: 'JP'
}, {
  name: '加拿大',
  english: 'CA'
}, {
  name: '法国',
  english: 'FR'
}, {
  name: '韩国',
  english: 'KR'
}, {
  name: '德国',
  english: 'DE'
}, {
  name: '澳大利亚',
  english: 'AU'
}, {
  name: '奥地利',
  english: 'AT'
}, {
  name: '波兰',
  english: 'PL'
}, {
  name: '丹麦',
  english: 'DK'
}, {
  name: '俄罗斯',
  english: 'RU'
}, {
  name: '荷兰',
  english: 'NL'
}, {
  name: '其他',
  english: 'QT'
}]



// WEBPACK FOOTER //
// ./src/comm/utils/nationalityUtil.js